module.exports = __webpack_public_path__ + "static/media/Univers-bold.a5c14cf1.woff2";